import notistack from "pages/Core/Notistack";
import { postLogin } from "../../../helpers/backend-helper";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from "./reducer";
import { setAuthorization } from "helpers/api_helper";

// Login Action
export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const response = await postLogin({
      userName: user.userName, // using 'code' as 'email'
      password: user.password,
    });
    notistack.notifyFromApi(response);
    if (response?.data) {
      const userData = response.data;
      localStorage.setItem("authUser", JSON.stringify(userData));
      localStorage.setItem("token", userData.token);
      dispatch(loginSuccess(userData));
      setAuthorization(userData?.token );
      history("/dashboard");
    } else {
      dispatch(apiError("Invalid response"));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

// Logout Action
export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error));
  }
};
